export default __webpack_public_path__ + "static/media/reset.a5f0659e.svg";